export default "__VITE_ASSET__f5cc06c4__"